import * as React from "react";
// import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import { printPDF } from "../../../services/utility/textFormatService";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import consentRequestService from "../../../services/mandate/consentRequestService";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
// import { getCurrentUsersRoles } from "../../../services/auth/authService";
import ConsentRequestDetail from "./consentRequestDetail";

export interface ConsentRequestsProps { }

export interface ConsentRequestsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class ConsentRequestsList extends BaseListComponent<ConsentRequestsState> { }

class ConsentRequests extends React.Component<
  ConsentRequestsProps,
  ConsentRequestsState
> {
  constructor(props: ConsentRequestsProps) {
    super(props);
    this.state = {
      data: createFilterData([
        "phoneNumber",
        "bvn",
        "requestStatus",
      ]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        { name: "phoneNumber", fieldType: "text", value: "" },
        { name: "bvn", fieldType: "text", value: "" },
        {
          name: "requestStatus",
          fieldType: "select",
          options: [
            "AwaitingConfirmation",
            "Confirmed",
            "Cancelled",
            "Delivered",
            "Failed",
          ],
          value: "",
        },
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 || !pageSize ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    // const decodedToken = decodeToken(getCurrentUserSession().token || "");
    let dataClone: IFilterData = typeof data === "undefined" ? { ...this.state.data } : { ...data };
    try {
      if (dataClone.phoneNumber.item2 === "") {
        delete dataClone.phoneNumber
      }
      if (dataClone.bvn.item2 === "") {
        delete dataClone.bvn
      }
      if (dataClone.requestStatus.item2 === "") {
        delete dataClone.requestStatus
      }
      // data.institutionId = {
      //   item1: "=",
      //   item2: decodedToken?.["InstitutionId"]?.toString() || "break",
      // };
      // data.customerType = {
      //   item1: "=",
      //   item2: "Beneficiary",
      // };

      const consentRequests = await consentRequestService.filterConsentRequests(
        dataClone,
        pageSize,
        currentPage
      );

      consentRequests.data.item2.forEach((request) => {
        if (request.repaymentType === "Collection") {
          request.repaymentType = "Collection & Recovery";
        }
      });
      // console.log("consentRequests: ", consentRequests);
      this.setState({
        tableItems: mapEntityList({
          entityList: consentRequests.data.item2,
          properties: [
            { oldName: "customerName", newName: "Name" },
            { oldName: "bvn", newName: "bvn" },
            {
              isTag: true,
              oldName: "customerType",
              newName: "customerType",
              success: "success",
              danger: "danger",
              default: "default",
              primary: "Beneficiary",
              secondary: "Guarantor",
              warning: "warning",
              light: "light",
              dark: "dark",
            },
            {
              isTag: true,
              oldName: "repaymentType",
              newName: "repaymentType",
              success: "Collection & Recovery",
              danger: "danger",
              default: "default",
              primary: "Recovery",
              secondary: "secondary",
              warning: "warning",
              light: "light",
              dark: "dark",
            },
            { oldName: "phoneNumber", newName: "phoneNumber" },
            { oldName: "loanAmount", newName: "loanAmount" },
            {
              oldName: "totalRepaymentExpected",
              newName: "totalRepaymentExpected",
            },
            { oldName: "consentReceiptDate", newName: "consentReceiptDate" },
            {
              isTag: true,
              oldName: "requestStatus",
              newName: "requestStatus",
              success: "Disbursed",
              danger: "Failed",
              default: "AwaitingDisbursement",
              primary: "Confirmed",
              secondary: "secondary",
              warning: "Cancelled",
              light: "AwaitingConfirmation",
              dark: "dark",
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: consentRequests.data.item1,
        fetching: false,
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        // this.setState({ errors, fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        // this.setState({ errors, fetching: false });
      }
    }
  };

  handleOnExport = async (type: string) => {
    try {
      switch (type) {
        case "XLSX":
        case "CSV":
          return await consentRequestService.downloadReport(type);
        case "PDF":
          const response = await consentRequestService.downloadReportPDF();
          printPDF(response.data);
          break;
        default:
          break;
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        //this.setState({ errors, fetching: false });
      }
    }
  };

  fetchItemById = async (item: any) => {
    // await activityTrailService.saveActivityTrail({
    //   actionType: "View Details",
    //   description: `Viewed details of Branch ${item.name}`
    // });
    this.setState({ fetchingDetail: true });
    // console.log("fetching branch with id: ", item.id);
    const request = await consentRequestService.retrieveConsentRequestById(
      item.id
    );
    // console.log("consent request: ", request.data);
    if (request.data.hasGuarantor) {
      request.data.guarantorConsentRequests?.forEach((element) => {
        element.totalRepaymentExpected =
          0.01 *
          element.guaranteeingPercentage *
          request.data.totalRepaymentExpected;
      });
    }
    this.setState({ item: request.data, fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      // data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    // let filteredItems: IFilterData = {};
    // Object.keys(data).forEach((key) => {
    //   if (data[key].item2 !== "") {
    //     filteredItems[key] = data[key];
    //   }
    // });
    // console.log("data", data);
    // console.log("filteredItems", filteredItems);
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Consent Requests</b>
              </h3>
            </div>
            <ConsentRequestsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([
                  "phoneNumber",
                  "bvn",
                  "requestStatus",
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [
                  { name: "phoneNumber", fieldType: "text", value: "" },
                  { name: "bvn", fieldType: "text", value: "" },
                  {
                    name: "requestStatus",
                    fieldType: "select",
                    options: [
                      "AwaitingConfirmation",
                      "Confirmed",
                      "Cancelled",
                      "Delivered",
                      "Failed",
                    ],
                    value: "",
                  },
                ],
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
              }) => (
                <Fragment>
                  <ConsentRequestDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    handlePageChange={this.handlePageChange}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="ConsentRequests"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={[
                                "loanAmount",
                                "totalRepaymentExpected",
                              ]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></ConsentRequestsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ConsentRequests;
